import PaymentSystemButton from './PaymentSystemButton';

export default PaymentSystemButton;
